import { useCallback, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { loginUrlFor, withJamParams } from '../util/recordingNavigation'

interface Portal {
  custom_login_url?: string
}

export function useRedirectTo(portal: Portal = {}) {
  const history = useHistory()
  const location = useLocation()

  // Parse redirect_to from URL
  const parsedRedirectUrl = useMemo(() => {
    const query = new URLSearchParams(location.search)
    return query.get('redirect_to')
  }, [location.search])

  // Generate login URL with redirect parameter
  const generateLoginUrl = useCallback(
    (targetPath = `${window.location.pathname}${window.location.search}${window.location.hash}`) => {
      const loginPath = `/${portal.custom_login_url || 'log-in'}`
      return loginUrlFor(loginPath, withJamParams(targetPath, location.search))
    },
    [portal.custom_login_url, location.search]
  )

  // Execute redirect after sign-in
  const executeRedirect = useCallback(
    (fallbackPath = '/') => {
      history.push(withJamParams(parsedRedirectUrl || fallbackPath, location.search))
    },
    [history, location.search, parsedRedirectUrl]
  )

  return {
    redirectUrl: parsedRedirectUrl,
    generateLoginUrl,
    executeRedirect
  }
}
